import { useCallback, useState } from 'react'

/**
 * useState<Set<string>> with stable add/remove callbacks that no-op when the
 * value is already in (or already out of) the set. Returns [set, add, remove].
 */
export function useStringSet(initial?: Iterable<string>) {
  const [set, setSet] = useState<Set<string>>(() => new Set(initial))

  const add = useCallback((id: string) => {
    setSet((prev) => {
      if (prev.has(id)) return prev
      const next = new Set(prev)
      next.add(id)
      return next
    })
  }, [])

  const remove = useCallback((id: string) => {
    setSet((prev) => {
      if (!prev.has(id)) return prev
      const next = new Set(prev)
      next.delete(id)
      return next
    })
  }, [])

  return [set, add, remove] as const
}
